import { Lightning, Utils } from "@lightningjs/sdk";

export default class ChannelIcon extends Lightning.Component {
  action: any;
  _iconsvg: any;
  override _setup() {}

  static override _template() {
    return {
      h: 60,
      w: 60,
      rect: true,
      color: controlsBGColor,
      shader: { type: Lightning.shaders.RoundedRectangle,radius: 30 },
      Icon: {
        x: (w: any) => 15,
        y: (h: any) => 15,
        //mount: 0,
        /*w: 50,
        h: 50,
        x: 0,
        y: 0,*/
      },
    };
  }

  set iconsvg(v: any) {
    if (v) {
      this._iconsvg = v;
      this.tag("Icon").texture = Lightning.Tools.getSvgTexture(
        Utils.asset(`svg/${v}`),
        30,
        30
      );
    }
  }

  set iconWidth(v: any) {
    if(v){
      this.tag("Icon").w = v;
    }
  }

  set iconHeight(v: any) {
    if(v){
      this.tag("Icon").h = v;
    }
  }

  override _focus() {
    this.setSmooth("color", controlsBGColorFocus);
  }

  override _unfocus() {
    this.setSmooth("color", controlsBGColor);

  }
}
//const controlsBGColorFocus = 0xfff34966;
const controlsBGColorFocus = 0xffff0000;
const controlsBGColor = 0x2b333fb3;
